/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { pathRoutes } from 'libs/constans';
import { Redirect } from 'react-router-dom';

export default function Home() {

    return (
        <Redirect to={pathRoutes.WALLET_MANAGER} />
    )
}


